import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/attributeActions';

const attributeActions = {

    create(attribute) {
        return dispatch => {
            dispatch(actions.createAttribute());

            request
                .post(env.tashi + '/attributes')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createAttribute({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.createAttribute({ status: "success", data: attribute }));
                    } else {
                        dispatch(actions.createAttribute({ status: "failure", data: res.status }));
                    }

                });
        };
    },

    delete(attributeID) {
        return dispatch => {
            dispatch(actions.deletAttribute());

            request
                .del(env.tashi + '/attributes/' + attributeID)
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.deletAttribute({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.deletAttribute({ status: "success", data: attributeID }));
                    } else {
                        dispatch(actions.deletAttribute({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    loadAll() {
        return dispatch => {
            dispatch(actions.loadAllAttributes());

            request
                .get(env.tashi + '/attributes')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadAllAttributes({ status: "failure", data: err }));
                        return;
                    }
                    let data = JSON.parse(res.text)._embedded.attributes;

                    if (data) {
                        dispatch(actions.loadAllAttributes({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadAllAttributes({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadDefaultAttributes() {
        return dispatch => {
            dispatch(actions.loadAllAttributes());

            request
                .get(env.tashi + '/projects/loadDefaultAttributes')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadDefaultAttributes({ status: "failure", data: err }));
                        return;
                    }
                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadDefaultAttributes({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadDefaultAttributes({ status: "success", data: [] }));
                    }
                });
        };
    },

    setValue(projectID, attributeValue) {
        return dispatch => {
            dispatch(actions.projectSetAttributeValue());

            request
                .post(env.tashi + '/projects/' + projectID + '/setAttribute')
                .send(attributeValue)
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.projectSetAttributeValue({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.projectSetAttributeValue({ status: "success", data: {projectID, attributeValue} }));
                    } else {
                        dispatch(actions.projectSetAttributeValue({ status: "failure", data: res.status }));
                    }

                });
        };
    },

    setValues(projectID, attributeValues) {
        return dispatch => {
            dispatch(actions.projectSetAttributeValues());

            request
                .post(env.tashi + '/projects/' + projectID + '/setAttributes')
                .send(attributeValues)
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.projectSetAttributeValues({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.projectSetAttributeValues({ status: "success", data: {projectID, attributeValues} }));
                    } else {
                        dispatch(actions.projectSetAttributeValues({ status: "failure", data: res.status }));
                    }

                });
        };
    }

};

export default attributeActions;


/** WEBPACK FOOTER **
 ** ./src/app/actions/attributeActionCreators.js
 **/